// @flow

const routes = {
  '/app/connections': {
    fetch: () =>
      import(
        /* webpackChunkName: 'auth-connections-route' */ 'app/auth/asyncConnectionsRoute'
      ).then(module => module.default),
  },
  '/engine/auth/start/:api': {
    fetch: () =>
      import(
        /* webpackChunkName: 'auth-engine-route' */ 'app/auth/asyncEngineRoute'
      ).then(module => module.default),
  },
};

export default routes;
